import { Banner, BannerLinkType } from 'types';

export type BannerDestination =
  | { kind: 'none' }
  | { kind: 'internal'; to: string; newTab: boolean }
  | { kind: 'external'; href: string; newTab: boolean };

const ABSOLUTE_URL = /^https?:\/\//i;

const NONE: BannerDestination = { kind: 'none' };

// Banners criados antes do campo linkType nao o possuem: deriva o tipo do que esta preenchido.
function resolveLinkType(banner: Banner): BannerLinkType {
  if (banner.linkType) {
    return banner.linkType;
  }
  if (banner.file?.url) {
    return 'file';
  }
  return banner.url?.trim() ? 'link' : 'none';
}

export function resolveBannerDestination(banner: Banner): BannerDestination {
  switch (resolveLinkType(banner)) {
    case 'file': {
      const href = banner.file?.url?.trim();
      // Arquivo sempre em nova aba: o navegador renderiza o PDF sem tirar o usuario do app.
      return href ? { kind: 'external', href, newTab: true } : NONE;
    }

    case 'link': {
      const url = banner.url?.trim();
      if (!url) {
        return NONE;
      }
      // O <Link> do react-router resolve tudo como rota interna e quebraria uma URL absoluta.
      if (ABSOLUTE_URL.test(url)) {
        return { kind: 'external', href: url, newTab: !!banner.openNewTab };
      }
      return { kind: 'internal', to: url, newTab: !!banner.openNewTab };
    }

    default:
      return NONE;
  }
}
